/* eslint-disable no-restricted-imports */
import React from 'react'

import { useConnect } from 'redux-bundler-hook'

import { CircularProgress, Grid } from '@mui/material'

import { defer } from '~/src/Lib/Utils'

const QRCodeRoute = () => {
  const {
    routeInfo: { params: { sn } },
    doDeviceListSetSearch,
    doUpdateUrl,
  } = useConnect('selectRouteInfo', 'doDeviceListSetSearch', 'doUpdateUrl')

  if (sn) doDeviceListSetSearch(sn, false)

  defer(() => {
    doUpdateUrl('/setup/devices')
  }, defer.priorities.low)

  return (
    <Grid item style={{ flexGrow: 1 }} className="text-center">
      <CircularProgress className="text-center mar-t-xl" />
    </Grid>
  )
}

export default QRCodeRoute
/* eslint-enable no-restricted-imports */
